(function () {
    var SEL = 'shopify-accelerated-checkout-cart';

    function stripOne(acc) {
      if (!acc || acc.dataset.clShopPayStripped) return;

      var raw = acc.getAttribute('wallet-configs');
      if (!raw) return;

      var configs;
      try {
        configs = JSON.parse(raw);
      } catch (e) {
        return;
      }
      if (!Array.isArray(configs)) return;

      var kept = configs.filter(function (wallet) {
        return wallet && wallet.name !== 'shop_pay';
      });

      /* Không có Shop Pay trong danh sách (Shopify đổi cấu hình, hoặc đã tắt ở
         admin) thì đánh dấu rồi thôi — đừng thay node vô ích. */
      if (kept.length === configs.length) {
        acc.dataset.clShopPayStripped = '1';
        return;
      }

      var clone = acc.cloneNode(true);
      clone.setAttribute('wallet-configs', JSON.stringify(kept));
      clone.dataset.clShopPayStripped = '1';

      var button = clone.querySelector('shop-pay-wallet-button');
      if (button) button.remove();

      /* Thay node thay vì sửa tại chỗ: custom element chỉ đọc wallet-configs lúc
         khởi tạo, sửa thuộc tính của node đang sống thì nó không dựng lại. */
      acc.replaceWith(clone);
    }

    /* Cả trang giỏ lẫn ngăn giỏ đều có thể cùng tồn tại trên một trang. */
    function strip() {
      document.querySelectorAll(SEL).forEach(stripOne);
    }

    strip();

    /* Cụm ví do script của Shopify chèn vào sau, không có sẵn lúc trang tải. */
    var ticks = 0;
    var timer = setInterval(function () {
      strip();
      if (++ticks >= 20) clearInterval(timer);
    }, 300);

    /*
      Theo dõi lâu dài, KHÔNG đặt hạn giờ: ngăn giỏ hàng có thể mở lần đầu sau
      nhiều phút, lúc đó Shopify mới dựng cụm ví trong đó.

      Gộp nhiều thay đổi DOM vào một lần chạy bằng requestAnimationFrame — nếu
      không, hàm này chạy theo từng mutation một, mà trang giỏ thì mutation liên
      tục mỗi lần đổi số lượng.
    */
    if (window.MutationObserver) {
      var queued = false;
      var observer = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          strip();
        });
      });

      /* Chính lệnh replaceWith ở trên cũng kích hoạt observer, nhưng node mới đã
         mang dấu nên stripOne() thoát ngay — không thành vòng lặp. */
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
